module.exports = __webpack_public_path__ + "static/media/20000526_1.ef3c3446.jpg";